"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var dataUtils = new _mmcDataUtilities["default"]();
var appendImageOptimization = dataUtils.appendImageOptimization;
var imageWidth = 1000;
var isBackground = false;
var isWebp = true;
var imageQuality = 70;

var ConfiguratorCarouselImage = function ConfiguratorCarouselImage(_ref) {
  var image = _ref.image,
      altText = _ref.altText,
      order = _ref.order;

  var imageRef = _react["default"].useRef(null);

  _react["default"].useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Load the image when it becomes visible
          if (!imageRef.current.src) {
            imageRef.current.src = appendImageOptimization(image, imageWidth, isBackground, isWebp, imageQuality);
          }

          if (!imageRef.current.srcset) {
            imageRef.current.srcset = [appendImageOptimization(image, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(image, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(image, 640, isBackground, isWebp, imageQuality) + " 640w", appendImageOptimization(image, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(image, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(image, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(',');
          }
        }
      });
    }); // Observe the image element

    observer.observe(imageRef.current); // Clean up when the component unmounts

    return function () {
      return observer.disconnect();
    };
  }, [image]);

  return /*#__PURE__*/_react["default"].createElement("li", {
    style: {
      order: order
    },
    key: image
  }, /*#__PURE__*/_react["default"].createElement("img", {
    ref: imageRef,
    sizes: "(min-width: 768px) 70vw, 50vw",
    alt: altText
  }));
};

var _default = ConfiguratorCarouselImage;
exports["default"] = _default;